import { FileUpload } from "../../models/Entities/Contracts/FileUpload";
import { ErrorType } from "../../models/HttpError";

// File Upload get all actions
export const FILE_UPLOAD_GET_ALL_REQUEST = 'FILE_UPLOAD_GET_ALL_REQUEST';
export const FILE_UPLOAD_GET_ALL_SUCCESS = 'FILE_UPLOAD_GET_ALL_SUCCESS';
export const FILE_UPLOAD_GET_ALL_FAILURE = 'FILE_UPLOAD_GET_ALL_FAILURE';

export interface FileUploadGetAllRequestAction {
    type: typeof FILE_UPLOAD_GET_ALL_REQUEST;
    ContractId: number;
}

export interface FileUploadGetAllSuccessAction {
    type: typeof FILE_UPLOAD_GET_ALL_SUCCESS;
    Files: FileUpload[];
}

export interface FileUploadGetAllFailureAction {
    type: typeof FILE_UPLOAD_GET_ALL_FAILURE;
    error: ErrorType;
}

// File Upload get by ID actions
export const FILE_UPLOAD_GET_BY_ID_REQUEST = 'FILE_UPLOAD_GET_BY_ID_REQUEST';
export const FILE_UPLOAD_GET_BY_ID_SUCCESS = 'FILE_UPLOAD_GET_BY_ID_SUCCESS';
export const FILE_UPLOAD_GET_BY_ID_FAILURE = 'FILE_UPLOAD_GET_BY_ID_FAILURE';

export interface FileUploadGetByIdRequestAction {
    type: typeof FILE_UPLOAD_GET_BY_ID_REQUEST;
    FileId: number;
}

export interface FileUploadGetByIdSuccessAction {
    type: typeof FILE_UPLOAD_GET_BY_ID_SUCCESS;
    File: FileUpload;
}

export interface FileUploadGetByIdFailureAction {
    type: typeof FILE_UPLOAD_GET_BY_ID_FAILURE;
    error: ErrorType;
}

// File Upload create actions
export const FILE_UPLOAD_CREATE_REQUEST = 'FILE_UPLOAD_CREATE_REQUEST';
export const FILE_UPLOAD_CREATE_SUCCESS = 'FILE_UPLOAD_CREATE_SUCCESS';
export const FILE_UPLOAD_CREATE_FAILURE = 'FILE_UPLOAD_CREATE_FAILURE';

export interface FileUploadCreateRequestAction {
    type: typeof FILE_UPLOAD_CREATE_REQUEST;
    File: FileUpload;
}

export interface FileUploadCreateSuccessAction {
    type: typeof FILE_UPLOAD_CREATE_SUCCESS;
    File: FileUpload;
}

export interface FileUploadCreateFailureAction {
    type: typeof FILE_UPLOAD_CREATE_FAILURE;
    error: ErrorType;
}

// File Delete actions
export const FILE_UPLOAD_DELETE_REQUEST = 'FILE_UPLOAD_DELETE_REQUEST';
export const FILE_UPLOAD_DELETE_SUCCESS = 'FILE_UPLOAD_DELETE_SUCCESS';
export const FILE_UPLOAD_DELETE_FAILURE = 'FILE_UPLOAD_DELETE_FAILURE';

export interface FileUploadDeleteRequestAction {
    type: typeof FILE_UPLOAD_DELETE_REQUEST;
    FileId: number;
}

export interface FileUploadDeleteSuccessAction {
    type: typeof FILE_UPLOAD_DELETE_SUCCESS;
    FileId: number;
}

export interface FileUploadDeleteFailureAction {
    type: typeof FILE_UPLOAD_DELETE_FAILURE;
    error: ErrorType;
}
